import { render, staticRenderFns } from "./ReferralUploadTable.vue?vue&type=template&id=e1bf1ab2&scoped=true&"
import script from "./ReferralUploadTable.vue?vue&type=script&lang=js&"
export * from "./ReferralUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./ReferralUploadTable.vue?vue&type=style&index=0&id=e1bf1ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bf1ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
